module.exports = __webpack_public_path__ + "img/evo-big.6437d49f.png";